<div class="main-content">
    <div class="container-fluid tp-box" [@flipState]="flip">
        <div class="row tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">
            <div class="card">
                <div class="card-header card-header-{{ color }}-3 pointer">
                    <h4 class="card-title "> <i class="material-icons pointer" (click)="toggleFlip('')">arrow_left</i>
                        {{ viewing }} </h4>
                    <p class="card-category"></p>
                </div>
                <div class="card-body mt-0 mb-0 pt-0 pb-0">
                    <ng-container [ngSwitch]="viewing">
                        <ng-container *ngSwitchCase="'Needs Bin'">
                            <app-need-bin-location></app-need-bin-location>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Negative Inventory'">
                            <app-negative-items></app-negative-items>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Open Orders'">
                            <app-open-orders (preorderloaded)="selectItemLookup($event);"
                                (orderloaded)="selectItemLookup($event)" [customerdata]="''"
                                (orderinvoice)="invoiceOrder($event)"></app-open-orders>
                        </ng-container>
                        <ng-container *ngIf="config.env.package == 'beauty'">
                            <ng-container *ngSwitchCase="'Gap Report'">
                                <app-gapp-report></app-gapp-report>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Open Quotes'">
                                <!-- <app-open-quotes [quoteData]="openquotes"></app-open-quotes> -->
                                <app-quote-list (orderloaded)="selectItemLookup($event)"></app-quote-list>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngIf="userComponentArray.length">
            <div class="row col-12" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
                <ng-container *ngFor="let comp of userComponentArray">
                    <div class="col-lg-{{comp['cardsize']}} col-md-{{comp['cardsize']}} col-sm-{{comp['cardsize']}}">
                        <ng-container *ngComponentOutlet="comp['component']; injector: comp['injector']"></ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>